/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Результат выполнения команды DisableRecurrentPaymentRequest.
 * @export
 * @interface FxIdApplicationStoreBank131DisableRecurrentPaymentResponse
 */
export interface FxIdApplicationStoreBank131DisableRecurrentPaymentResponse {
    /**
     * Флаг успешности отключения рекуррентного платежа.
     * @type {boolean}
     * @memberof FxIdApplicationStoreBank131DisableRecurrentPaymentResponse
     */
    Success: boolean;
}

/**
 * Check if a given object implements the FxIdApplicationStoreBank131DisableRecurrentPaymentResponse interface.
 */
export function instanceOfFxIdApplicationStoreBank131DisableRecurrentPaymentResponse(value: object): value is FxIdApplicationStoreBank131DisableRecurrentPaymentResponse {
    if (!('Success' in value) || value['Success'] === undefined) return false;
    return true;
}

export function FxIdApplicationStoreBank131DisableRecurrentPaymentResponseFromJSON(json: any): FxIdApplicationStoreBank131DisableRecurrentPaymentResponse {
    return FxIdApplicationStoreBank131DisableRecurrentPaymentResponseFromJSONTyped(json, false);
}

export function FxIdApplicationStoreBank131DisableRecurrentPaymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreBank131DisableRecurrentPaymentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'Success': json['Success'],
    };
}

export function FxIdApplicationStoreBank131DisableRecurrentPaymentResponseToJSON(json: any): FxIdApplicationStoreBank131DisableRecurrentPaymentResponse {
    return FxIdApplicationStoreBank131DisableRecurrentPaymentResponseToJSONTyped(json, false);
}

export function FxIdApplicationStoreBank131DisableRecurrentPaymentResponseToJSONTyped(value?: FxIdApplicationStoreBank131DisableRecurrentPaymentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Success': value['Success'],
    };
}

